import React from 'react'
import AdminHeader from '../AdminHeader'
import Terminals from '../Terminals'
import LocationsSettings from '../LocationsSettings'
import Departures from '../Departures'
import DropdownComponent from '../DropdownComponent'
import './main.less'
import { connect } from 'react-redux'
import { AppState } from '../../../reducers'
import {
  setToggleOpeningLocationSettingsAction,
  setToggleOpeningTerminalsAction,
  setToggleOpeningDeparturesAction,
} from '../../../actions/admin/adminTerminals'

const mapStateToProps = (state: AppState) => ({
  isLocationsSettingsOpened: state.adminTerminals.isLocationsSettingsOpened,
  isTerminalsOpened: state.adminTerminals.isTerminalsOpened,
  isDeparturesOpened: state.adminTerminals.isDeparturesOpened,
})

const mapDispatchToProps = {
  setToggleOpeningLocationSettings: setToggleOpeningLocationSettingsAction,
  setToggleOpeningTerminals: setToggleOpeningTerminalsAction,
  setToggleOpeningDepartures: setToggleOpeningDeparturesAction,
}

type DispatchProps = typeof mapDispatchToProps

type StateProps = ReturnType<typeof mapStateToProps>
type Props = StateProps & DispatchProps

const Component: React.FC<Props> = ({
  isLocationsSettingsOpened,
  isTerminalsOpened,
  isDeparturesOpened,
  setToggleOpeningLocationSettings,
  setToggleOpeningTerminals,
  setToggleOpeningDepartures,
}: Props) => {
  return (
    <div className="admin-main">
      <AdminHeader />
      <DropdownComponent
        titleName="Allowed to CheckIn locations"
        isOpened={isLocationsSettingsOpened}
        toggleOpening={() => setToggleOpeningLocationSettings()}
      >
        <LocationsSettings />
      </DropdownComponent>
      <DropdownComponent
        titleName="Terminals"
        isOpened={isTerminalsOpened}
        toggleOpening={() => setToggleOpeningTerminals()}
      >
        <Terminals />
      </DropdownComponent>
      <DropdownComponent
        titleName="Departures for next 24 hours"
        isOpened={isDeparturesOpened}
        toggleOpening={() => setToggleOpeningDepartures()}
      >
        <Departures />
      </DropdownComponent>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
